<template>

  <div>
    <div class="vx-col w-full">
      <vs-input icon-pack="feather" icon="icon-user" label-placeholder="Name" name="name" v-validate="'required'" v-model="products.buyerName" class="is-label-placeholder w-full" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
    </div>

    <div class="vx-col w-full">
      <vs-input icon-pack="feather" icon="icon-smartphone" label-placeholder="Phone No" name="phone" v-validate="'required'" v-model="products.phoneNumber" class="is-label-placeholder w-full" />
        <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
    </div>

    <div class="vx-col w-full" :key="indextr" v-for="(row, indextr) in products.custom_field">
      <div v-if="row.name!=='Name' && row.name!=='Phone'">
          <vs-input v-if="row.required===true && row.type==='text'" icon-pack="feather" icon="icon-user" :label-placeholder="row.name" :name="row.custom_field_id" v-validate="'required'" v-model="row.value" class="is-label-placeholder w-full" />
          <vs-input v-if="row.required===false && row.type==='text'" icon-pack="feather" icon="icon-user" :label-placeholder="row.name" :name="row.custom_field_id" v-validate="" v-model="row.value" class="is-label-placeholder w-full" />
          <vs-input v-if="row.required===true && row.type==='email'" icon-pack="feather" icon="icon-mail" :label-placeholder="row.name" :name="row.custom_field_id" v-validate="'required|email'" v-model="row.value" class="is-label-placeholder w-full" />
          <vs-input v-if="row.required===false && row.type==='email'" icon-pack="feather" icon="icon-mail" :label-placeholder="row.name" :name="row.custom_field_id" v-validate="'email'" v-model="row.value" class="is-label-placeholder w-full" />
          <vs-input v-if="row.required===true && row.type==='number'" icon-pack="feather" icon="icon-help-circle" :label-placeholder="row.name" :name="row.custom_field_id" v-validate="'required|numeric'" v-model="row.value" class="is-label-placeholder w-full" />
          <vs-input v-if="row.required===false && row.type==='number'" icon-pack="feather" icon="icon-help-circle" :label-placeholder="row.name" :name="row.custom_field_id" v-validate="'numeric'" v-model="row.value" class="is-label-placeholder w-full" />
          <flat-pickr v-if="row.type==='date'" :config="configdateTimePicker" v-model="row.value" :placeholder="row.name" class="mt-5"/>

          <span  v-if="row.type==='yesno'"  class="w-full block mt-5">
            {{row.name}}
            <vs-radio v-model="row.value" vs-value="yes" class="align-middle">Yes</vs-radio> &nbsp;
            <vs-radio v-model="row.value" vs-value="no" class="align-middle">No</vs-radio>
          </span>
          <span  class="text-danger text-sm" v-show="errors.has(`${row.custom_field_id}`)">{{ errors.first(`${row.custom_field_id}`) }}</span>
      </div>
    </div>

    <vs-divider/>

      <div v-if="products.layout===0">
        <!-- start untuk list yeah-->
        <p class="text-center">Select product</p>

        <v-select :options="products.productlist" :clearable="false" v-model="productMethod" v-on:input="changeSelection" class="mt-4" >
          <template slot="option" slot-scope="option">
            <div class="vx-col w-full">
              <!--<img :src="option.image.feature.Location" class="product-img border border-solid d-theme-border-grey-light rounded-lg w-16 md:w-24 p-4" />-->
          <h6 class="product-name font-medium truncate mt-4">{{ option.label }}</h6>
          <!--p class="product-variation mt-4">{{ option.description }}</p>-->
            </div>
          </template>`
        </v-select>
        <div class="centerx flex mt-4">
          <vs-input-number name="sitebg" min="0" v-model="productAmount" :max="maxProductAmount" v-on:input="totalChange2" class="mx-auto"/>
        </div>

        <vs-divider/>

          <div class="vx-row mt-2">
            <div class="vx-col w-1/2 lg:w-4/5 text-right">
              <p>Sub Total :</p>
              <p>Tax :</p>
              <p><strong>Total :</strong></p>
              <!--<p>Coupon Code :</p>-->
            </div>
            <div class="vx-col w-1/2 lg:w-1/5 text-right">
              <p>RM {{total }}</p>
              <p>0 %</p>
              <p><strong>RM {{total}}</strong></p>
              <!--<p><a class="cursor-pointer" @click="couponPopup=true">Select Coupon</a></p>-->
            </div>
          </div>
          <vs-popup title="Billing Address" :active.sync="couponPopup">
            <div class="vx-row">
              <div class="vx-col w-full mb-2">
                <vs-input class="w-full" label-placeholder="Enter Code Here" v-model="couponCode" />
              </div>
            </div>
            <div>
              <div class="centerx mt-4 md:flex">
                <vs-button type="border" icon-pack="feather" icon="icon-x" >Cancel</vs-button>
                <vs-button type="filled" icon-pack="feather" icon="icon-check" class="shadow-md ml-auto" >Apply</vs-button>
              </div>
            </div>
          </vs-popup>

          <vs-divider/>


            <div class="centerx mt-4 md:flex">
              <vs-button type="filled" icon-pack="feather" icon="icon-shopping-bag" class="ml-auto shadow-md hidden md:flex order-2" @click.stop="orderNow('list','direct')">Buy Now</vs-button>
              <vs-button type="filled" class="ml-auto shadow-md md:hidden w-full text-center mb-4" @click.stop="orderNow('list','direct')">Buy Now</vs-button>
              <vs-button color="rgb(11, 189, 135)" type="border" icon-pack="feather" icon="icon-message-circle" class="shadow-md hidden md:flex order-1" @click.stop="orderNow('list','message')">Send Message</vs-button>
              <vs-button color="rgb(11, 189, 135)" type="border" class="shadow-md md:hidden w-full text-center">Send Message</vs-button>
            </div>

            <!--end for list-->
      </div>

      <div v-else-if="products.layout===1">
        <!--start for grid-->
        <vs-table stripe :data="products.productvariant" class="table-fixed">      
          <template slot-scope="{data}">
            <tbody>
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td class="img-container">
                  <img :src="tr.image.feature.Location" v-if="tr.image!==''" class="product-img border border-solid d-theme-border-grey-light rounded-lg w-16 md:w-24 p-4" />                              
                  <h6 class="product-name font-medium">{{ tr.name }}</h6>
                  <p class="product-variation">{{ tr.description }}</p><!-- replace this with Variation, now is display purpose only -->

                  <!-- <br/>
                    <div class="flex lg:hidden mobile-flex-center" v-for="(option, indexoption) in tr.option" :key="indexoption">
                    <div >
                    <h6 class="product-price"><span v-if="option.option!==''"> {{ option.option }} -</span> RM {{ option.price }}</h6>
                    <div class="flex"> 
                    <vs-input-number min="0" :max="option.inventory_count" v-model="option.order_count"  v-on:input="totalChange" />
                    </div>
                    </div>
                    <div>
                    </div>
                    </div> -->
                </vs-td>


                <!-- <vs-td class="price-container hidden lg:table-cell"> -->
                <vs-td class="price-container">

                  <vs-table :data="tr.option">
                    <template slot-scope="{data}">
                      <!-- <vs-tr v-for="(option, indexoption) in tr.option" :key="indexoption">-->
                      <vs-tr :key="indexoption" v-for="(option, indexoption) in data">
                        <vs-td class="td-product-price table-row lg:table-cell">
                          <h6 class="product-price" >
                            <span v-if="option.option!==''" class="product-variation"> {{ option.option }} <br/></span> <vs-chip color="primary">RM {{ option.price }}</vs-chip>
                          </h6>
                        </vs-td>
                        <vs-td class="td-product-count table-row lg:table-cell">
                          <vs-input-number min="0" size="medium"   :max="option.inventory_count" v-model="option.order_count" v-on:input="totalChange"/>
                        </vs-td>
                        <vs-td class="hidden lg:table-cell">
                          <h6 class="product-price" >RM {{ (option.price * option.order_count).toFixed(2) }}</h6>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

                </vs-td>
                <!--<vs-td class="hidden lg:table-cell">
                  <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" />
                  </vs-td>-->
                      </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <div class="vx-row mt-2">
          <div class="vx-col w-1/2 lg:w-4/5 text-right">
            <p>Sub Total :</p>
            <p>Tax :</p>
            <p><strong>Total :</strong></p>
            <!--<p>Coupon Code :</p>-->
          </div>
          <div class="vx-col w-1/2 lg:w-1/5 text-right">
            <p>RM {{total }}</p>
            <p>0 %</p>
            <p><strong>RM {{total}}</strong></p>
            <!--<p><a class="cursor-pointer" @click="couponPopup=true">Select Coupon</a></p>-->
          </div>
        </div>
        <vs-popup title="Billing Address" :active.sync="couponPopup">
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <vs-input class="w-full" label-placeholder="Enter Code Here" v-model="couponCode" />
            </div>
          </div>
          <div>
            <div class="centerx mt-4 md:flex">
              <vs-button type="border" icon-pack="feather" icon="icon-x" >Cancel</vs-button>
              <vs-button type="filled" icon-pack="feather" icon="icon-check" class="shadow-md ml-auto" >Apply</vs-button>
            </div>
          </div>
        </vs-popup>

        <vs-divider/>

        <div class="centerx mt-4 md:flex">
          <vs-button type="filled" icon-pack="feather" icon="icon-shopping-bag" class="ml-auto shadow-md hidden md:flex order-2" @click.stop="orderNow('grid','direct')">Buy Now</vs-button>
          <vs-button type="filled" class="ml-auto shadow-md md:hidden w-full text-center mb-4" @click.stop="orderNow('grid','direct')">Buy Now</vs-button>
          <vs-button color="rgb(11, 189, 135)" type="border" icon-pack="feather" icon="icon-message-circle" class="shadow-md hidden md:flex order-1" @click.stop="orderNow('grid','message')">Send Message</vs-button>
          <vs-button color="rgb(11, 189, 135)" type="border" class="shadow-md md:hidden w-full text-center">Send Message</vs-button>
        </div>
      </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
import axios from '@/axios';
import router from '@/router';

const dialogs = {
  invalidOrder: (error) => {
    return {
      color: "danger", 
      title: "Order not Complete",
      text: "Oops, looks like some compulsory fields still not filled. Please try again after completing it.",
      accept: () => {
        //router.push('/forms');
      },
      close: () => {
        //router.push('/forms');
      }
    }
  }, 
}

export default {
  components:{
    vSelect,
    flatPickr 
  },

  data() {
    return {
      name: "",
      phone: "",
      productAmount: 0,
      maxProductAmount:0,
      couponPopup: false,
      couponCode: "",
      phoneNumber:"",
      buyerName:"",
      companyName:"",
      selectedProduct:null,
      productMethod: null,
      total:0.00,
      products:{},
      /*productOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],*/
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'Y-m-d'
      },

    }
  },

  created() {
    // this.$store.dispatch('form/getSinglePublishedForm')
    this.products= _.cloneDeep(this.$store.state.form.current_published_form);
    this.totalChange();
  },

  computed: {
    /*products() {

    },*/
    order() {
      return this.$store.state.order.current_order;
    },
    /*productlist(){
        return _.cloneDeep(this.$store.state.form.current_published_form.productlist);
    }*/
  },

  methods:{
    async orderNow(type,next) {
      //I put this method here so that for existing order can be used to update rather than insert


      this.$validator.validateAll().then(result => {
        if(type==="list" &&  this.productMethod===null)
        {
          this.$vs.dialog(dialogs.invalidOrder());
        }
        else
        {
          this.confirmOrderNow(type,next);
        }

      });  

      //alert(type);

    },

    async confirmOrderNow(type,next)
    {

      let the_form = Object();
      the_form.name = this.products.buyerName;
      the_form.phone = this.products.phoneNumber;
      the_form.country_code = "60";

      var variant = {}, orderproduct = [];

      console.log(type);
      if(type==="grid")
      {
        Object.entries(this.products.productvariant).forEach(([key, val]) => {

          Object.entries(val["option"]).forEach(([key2, val2]) => {
            var variant = {}
            if(val2.order_count!==0)
            {
              variant.product_id = val2.product_id;
              variant.variant_id = val2.variant_id;
              variant.quantity = val2.order_count;
              variant.discount = '0.00';
              variant.price_perquantity= val2.price;
              variant.is_price_update=0;
              variant.remarks='';
              variant.is_shipping_free=val2.is_shipping_free;
              //console.log(variant);
              orderproduct.push(variant);
            }
          });
        });
      }
      else{
        if(this.productMethod !==null)
        {
          variant.product_id = this.productMethod.product_id;
          variant.variant_id = this.productMethod.variant_id;
          variant.quantity = this.productAmount;
          variant.discount = '0.00';
          variant.price_perquantity= this.productMethod.price;
          variant.is_price_update=0;
          variant.remarks='';

          Object.entries(this.products.productvariant).forEach(([key2, val2]) => {
            if(val2.variant_id===this.productMethod.variant_id)
            {
              variant.is_shipping_free=val2.is_shipping_free;
            }
          });

          orderproduct.push(variant);
        }
      }


      if(orderproduct.length===0)
      {
        this.$vs.dialog(dialogs.invalidOrder());
        //break;
        return;
      }

      the_form.order_products = orderproduct;

      let temp_custom_value = {};

      if (!_.isEmpty(this.products.custom_field)) {
        temp_custom_value = this.products.custom_field.map((x) => {
          if (x.name.toLowerCase() === 'email') the_form.email = x.value;
          return {
            name: x.name,
            type: x.type,
            value: x.value,
          }
        });
      }

      the_form.custom_value = temp_custom_value;

      //console.log(the_form);

      //console.log(this.$route.params.formid);
      if(typeof this.$route.params.formid!=='undefined')
      {
        the_form.form_id = this.$route.params.formid;
        try {
          let res = await axios.post('/order', the_form);

          this.$vs.notify({
            color:'success',
            title:'Success',
            text:'Thank you, order has been added successfully'
          })

          let results = res;

          if(next==='direct')
          {
            router.push(`/address/${res.data.data.id}`);
          }
          else
          {
            //console.log(res.data.data.users[0].phone_number);
            let text ="Hi "+res.data.data.users[0].first_name+", \n\n I'm "+res.data.data.name+", \n\n I'm interested to buy your product. \n\n My Order here: https://quicksend.asia/order/"+res.data.data.id+" \n\n I would like to ask some questions before continuing. ";

            let text2 = encodeURI(text);

            let url="https://api.whatsapp.com/send?phone="+res.data.data.users[0].phone_number+"&text="+text2;

            location.assign(url);

          }

        }catch (e) {
          throw e;
          console.log(e);
        }
      }
      else
      {

        the_form.order_id = this.$route.params.orderid;
        try {
          let res = await axios.patch('/order', the_form);

          this.$vs.notify({
            color:'success',
            title:'Success',
            text:'Thank you, order has been updated successfully'
          })

          let results = res;

          if(next==='direct')
          {
            router.push(`/address/${res.data.data.id}`);
          }
          else
          {
            //console.log(res.data.data.users[0].phone_number);
          }


        }catch (e) {
          throw e;
          //console.log(e);
        }

      }
    },

    totalChange: function (){

      let newtotal=0.00;

      Object.entries(this.products.productvariant).forEach(([key, val]) => {
        Object.entries(val["option"]).forEach(([key2, val2]) => {
          let _price = parseFloat(val2.price);
          let _count = parseFloat(val2.order_count);
          if (!isNaN(_price) && !isNaN(_count)) {
            newtotal = newtotal + (_price * _count);
          }
        });

      });

      this.total=newtotal.toFixed(2);
      //option.price * option.order_count
    },
    changeSelection: function(){
      this.maxProductAmount=this.productMethod.inventory_count;
      this.productAmount=1;
      this.totalChange2();
    },
    totalChange2:function(){
      let newtotal=0.00;
      newtotal=this.productMethod.price*this.productAmount;
      this.total=newtotal.toFixed(2);
    }

  },
  mounted(){
    this.totalChange();
  }

}
</script>

<style>

/* .td.vs-table--td.image-container, .td.vs-table--td.control-container { max-width: 25%; } */
/* .td.vs-table--td.details-container { max-width: 50%; } */
.vs-table--tbody-table .vs-table--td.td.details-container > span { display: block; width: calc(20vw - (4rem + 60px)) !important; }
.vs-table--content .vs-con-table .vs-con-tbody {border: 0; background: none;}
.price-container {padding: 0 !important; vertical-align: top;}
.img-container {max-width: 250px; vertical-align: top;}
.vs-con-table.stripe .tr-values:nth-child(2n) {background: #ffffff !important;}
.vs-table--tbody-table tr {border-bottom: 2px solid #f8f8f8;}
.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {transform:none; -webkit-transform:none;}
.product-img {margin-bottom: 10px;}
.product-variation + .con-vs-chip {margin-top: 10px;}
.td-product-count {max-width: 100px;}
.td-product-count .vs-input-number {width: 50px;}
.td-product-price {max-width:50%; width:50%;}
.price-container .vs-table--td {padding: 20px 15px !important;}
@media screen and (max-width:768px) {
    .vs-table--tbody-table .vs-table--td.td.details-container > span { display: block; width: calc(47.5vw - (4rem + 60px)) !important; }
    .mobile-flex-center { align-items: center; justify-content: center; }

    .td-product-price {max-width:100%; width:100%;}
    .price-container .td > span {padding: 10px 15px; display: flex;}
    .td .vs-table--tbody-table {min-width: auto;}
    .td-product-count .vs-input-number {width: auto;}
}
@media screen and (max-width:576px) {
    .vs-table--tbody-table {min-width: auto; }
    .router-view { padding: 0.5rem !important; }
    .vs-table--tbody-table .vs-table--td.td.details-container > span { display: block; width: calc(80vw - (4rem + 60px)) !important; }
}
</style>
